import React from 'react'
import LegendPanel from './LegendPanel'
import { connect } from 'react-redux'
import { getFilteredUnitList, getUnitMap } from 'analytics/selectors'
import R from 'ramda'
import { scaleOrdinal } from 'd3-scale'
import { getSumData } from '../selectors'
import { fromNullable, Just, Nothing } from 'data.maybe'
import { svgHeight, svgWidth } from '../utils'
import { schemeCategory20 } from 'analytics'

const colorScale = scaleOrdinal(schemeCategory20)

const margin = { top: 20, right: 20, bottom: 30, left: 40 }

const filterData = (filtredUnits, data) =>
  data.filter(({ unitId }) => R.contains(unitId, filtredUnits))

const filterKeys = (flags, keys) => keys.filter(({ id }) => flags[id]).map(({ id }) => id)

class GeneralBarChart extends React.Component {
  constructor(props) {
    super(props)
    const { keys } = this.props
    const initialFlags = R.fromPairs(keys.map(({ id }) => [id, true]))
    this.state = {
      flags: initialFlags,
    }
    this.toggleFlag = this.toggleFlag.bind(this)
    this.setSelected = this.setSelected.bind(this)
  }

  selectAllMetrics = () =>
    this.setState({ flags: R.fromPairs(this.props.keys.map(({ id }) => [id, true])) })

  clearMetrics = () =>
    this.setState({ flags: R.fromPairs(this.props.keys.map(({ id }) => [id, false])) })

  toggleFlag(key) {
    const { flags } = this.state
    this.setState({
      flags: { ...flags, [key]: !flags[key] },
    })
  }

  setSelected(unitId, valType) {
    this.setState({
      selected: { unitId, valType },
    })
  }

  render() {
    const {
      //      screenSize: { width: screenWidth, height: screenHeight },
      screenSize,
      Chart,
      data,
      keys,
      filtredUnits,
      unitMap,
      maxValue,
    } = this.props

    const screenWidth = screenSize.width
    const screenHeight = screenSize.height

    const { flags, selected } = this.state

    const contentWidth = screenWidth - 280
    const contentHeight = screenHeight

    const width = svgWidth(contentWidth, margin)
    const height = svgHeight(contentHeight, margin)

    // todo: will recieve data from outside
    // const data = units.map(mockSummaryUnitData(keys,mockSpec))

    const filteredKeys = filterKeys(flags, keys)
    const filteredData = filterData(filtredUnits, data)

    const chartProps = {
      margin,
      colorScale,
      data: filteredData,
      unitMap,
      valueKeys: filteredKeys,
      width,
      height,
      contentWidth,
      contentHeight,
      setSelected: this.setSelected,
      maxValue,
      selected,
    }

    return (
      <div>
        <LegendPanel
          keys={keys}
          colorScale={colorScale}
          flags={flags}
          contentWidth={contentWidth}
          toggleFlag={this.toggleFlag}
          selectAll={this.selectAllMetrics}
          clearAll={this.clearMetrics}
        />
        <Chart {...chartProps} />
      </div>
    )
  }
}
const mapStateToProps = state => ({
  // screenSize: getScreenSize(state),
  data: getSumData(state),
  filtredUnits: getFilteredUnitList(state),
  unitMap: getUnitMap(state),
})

const Guard = props => {
  const { data, keys } = props
  const da = fromNullable(data)
    .chain(d => (d.length === 0 ? Nothing() : Just(d)))
    .chain(() => fromNullable(keys))
    .map(d => <GeneralBarChart key={d} {...props} />)
    .getOrElse(<div>No Data</div>)
  return da
}

export default connect(mapStateToProps)(Guard)
